/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import Col from 'react-bootstrap/Col';

import * as S from './styles';

export interface IHeroImageProps {
  image?: string;
  title?: string;
}

export const HeroImage = (props: IHeroProps) => {
  const { image, title } = props;
  return (
    <S.ImgCol xs={12} lg={2} className="">
      <S.ProfileImage
        src={image ?? `https://ui-avatars.com/api/?name=${title}`}
        alt={title}
        roundedCircle
      />
    </S.ImgCol>
  );
};

HeroImage.defaultProps = {
  image: '',
  title: '',
};
